import { ChannelManager } from 'app/typings/channelManagers';
import type { Hotel } from 'app/typings/hotels/Hotel/Hotel';
import type { ExtranetPackage, ExtranetRoom } from 'app/typings/packages';
import { addDays, isWithinInterval } from 'app/utils/dayjs';

import {
  CellIconColor,
  CellIconType,
} from '../_components/Cells/_components/CellIcon';
import type { FormPlanning } from '../type';

export const getRoomIconParameters = (
  hotel: Hotel | undefined,
  room: ExtranetRoom | undefined,
  datePlanning: FormPlanning,
  autoRow: boolean
) => {
  const autoCell = autoRow || !datePlanning.openingId;

  return {
    autoCell,
    iconColor: CellIconColor.Blue,
    iconType: CellIconType.AutoInventory,
    showIcon: !!hotel?.stockScrapperEnabled && !!room?.bookingcomId,
    openingInLastMinuteAutoDiscountRange:
      !!hotel?.lastMinuteAutoDiscountDays &&
      isWithinInterval(new Date(datePlanning.date), {
        start: addDays(new Date(), -1),
        end: addDays(new Date(), hotel?.lastMinuteAutoDiscountDays),
      }),
  };
};

export const getPackageIconParameters = (
  hotel: Hotel | undefined,
  pkg: ExtranetPackage | undefined,
  room: ExtranetRoom | undefined,
  datePlanning: FormPlanning
) => {
  if (!pkg) {
    return {
      showIcon: false,
      iconType: CellIconType.PricingRule,
      iconColor: CellIconColor.Grey,
      autoCell: false,
    };
  }

  const packagePrices = datePlanning.packagePrices[pkg.id];
  const openingInLastMinuteAutoDiscountRange =
    pkg?.lastMinuteAutoDiscountDays !== undefined &&
    isWithinInterval(new Date(datePlanning.date), {
      start: addDays(new Date(), -1),
      end: addDays(new Date(), pkg.lastMinuteAutoDiscountDays),
    });

  const pricingRuleGloballyActivated =
    !!pkg?.autoDiscountRate ||
    (!!pkg?.lastMinuteAutoDiscountRate && openingInLastMinuteAutoDiscountRange);

  const autoCell =
    packagePrices.discountPrice === undefined ||
    packagePrices.autoDiscount ||
    (packagePrices.lastMinuteAutoDiscount &&
      openingInLastMinuteAutoDiscountRange) ||
    (!packagePrices.packagePriceId &&
      (!!hotel?.stockScrapperEnabled || pricingRuleGloballyActivated));

  return {
    autoCell,
    iconColor: !!hotel?.stockScrapperEnabled
      ? CellIconColor.Blue
      : CellIconColor.Grey,
    iconType: CellIconType.PricingRule,
    showIcon:
      ((!!hotel?.stockScrapperEnabled && !!room?.bookingcomId) ||
        hotel?.channelManager !== ChannelManager.NONE) &&
      (!!pkg?.autoDiscountRate ||
        (!!pkg?.lastMinuteAutoDiscountRate &&
          openingInLastMinuteAutoDiscountRange)),
    openingInLastMinuteAutoDiscountRange,
  };
};
